__turbopack_context__.v({
  "active": "NavigationButton-module__vvzOcW__active",
  "button": "NavigationButton-module__vvzOcW__button",
  "icon": "NavigationButton-module__vvzOcW__icon",
  "item": "NavigationButton-module__vvzOcW__item",
});
